webClient.controller('B2B.avaloir', ['$scope', '$window', '$i18next',
    function ($scope, $window, $i18next) {
        
        getBundleWidget("mrfly-widget-avaloir-list.js").done(function () { });

        //This is only for debug
        $window.$scope = $scope;
    }]);
